import React from 'react';

import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';

import { analyticsClearEcommerce, analyticsPaymentInfo } from '../../middlewares/analytics/actions';

import Button from '../button/Button';
import PrimaryButton from '../button/PrimaryButton';
import FieldText from '../fields/fieldText/FieldText';
import FieldCheckbox from '../fields/fieldCheckbox/FieldCheckbox';
import CheckoutMethodField from './CheckoutMethodField';
import Pricing from '../pricing/Pricing';

@injectIntl
@reduxForm({
  form: 'checkout',
  validate: ({ tos_accepted, customer }) => ({
    tos_accepted: !tos_accepted ? <FormattedMessage id="section.auth.accept-tos" /> : undefined,
    customer: !(customer && customer.email) ? { email: 'This field is required' } : undefined,
  }),
})
@connect()
export default class CheckoutForm extends React.PureComponent {
  componentDidMount() {
    const { userProfile, checkoutMethods, change } = this.props;

    change('checkoutMethod', checkoutMethods[0].code);

    if (userProfile) {
      change('customer.email', userProfile.email);
      change('discord_username', userProfile.discordUsername);
      change('tos_accepted', userProfile.tosAccepted);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { userProfile, change } = nextProps;

    if (userProfile && this.props.userProfile !== userProfile) {
      change('customer.email', userProfile.email);
      change('discord_username', userProfile.discordUsername);
      change('tos_accepted', userProfile.tosAccepted);
    }
  }

  render() {
    const {
      dispatch,
      intl,
      userProfile,
      checkoutMethods,
      handleSubmit,
      submitting,
      submitSucceeded,
      error,
      cartItems,
      cartValue,
      cartOriginalValue,
      children,
      onSetCheckoutMethod,
    } = this.props;

    return (
      <div className="checkout__grid">
        <div className="checkout__cart">{children}</div>

        <form className="checkout__form-inner  form" onSubmit={handleSubmit}>
          <div className="checkout__fields">
            <Field
              label={intl.formatMessage({ id: 'page.checkout.field.email.label' })}
              name="customer.email"
              type="email"
              component={FieldText}
              className="field-text--checkout"
              placeholder={intl.formatMessage({ id: 'page.checkout.field.email.placeholder' })}
              disabled={!!userProfile}
            />

            <Field
              label="Discord"
              name="discord_username"
              type="text"
              component={FieldText}
              className="field-text--checkout"
              placeholder="Username"
            />
          </div>

          {cartValue > 0 && (
            <React.Fragment>
              <div className="checkout__subtitle">
                <FormattedMessage id="page.checkout.method" />
              </div>
              <Field
                name="checkoutMethod"
                methods={checkoutMethods}
                component={CheckoutMethodField}
                onMethodChange={(method) => {
                  onSetCheckoutMethod(method);

                  dispatch(analyticsClearEcommerce());
                  dispatch(analyticsPaymentInfo(method, cartItems));
                }}
              />
            </React.Fragment>
          )}

          <div className="checkout__actions">
            <div className="checkout__tos">
              <Field name="tos_accepted" component={FieldCheckbox}>
                <FormattedMessage id="section.tos.agree" />{' '}
                <a href="/page/terms-of-service" target="_blank">
                  <FormattedMessage id="section.tos.terms" />
                </a>
                {', '}
                <a href="/page/privacy-policy" target="_blank">
                  <FormattedMessage id="section.tos.privacy-policy" />
                </a>{' '}
                <FormattedMessage id="section.tos.and" />{' '}
                <a href="/page/refund-policy" target="_blank">
                  <FormattedMessage id="section.tos.refund-policy" />
                </a>
              </Field>

              {(!userProfile || !userProfile.newsletterSubscribed) && (
                <Field name="newsletter_subscribed" component={FieldCheckbox}>
                  <FormattedMessage id="section.subscribe" />
                </Field>
              )}
            </div>

            {error && <div className="form__error">{error}</div>}
            <div className="checkout__submit">
              <PrimaryButton
                type="submit"
                big
                full
                loading={submitting}
                disabled={submitting || submitSucceeded}
              >
                <FormattedMessage id="section.generic.proceed-to-payment" />
              </PrimaryButton>
            </div>

            <div className="checkout__fixed">
              <div className="checkout__fixed-total">
                <div className="checkout__fixed-title">
                  Amount to pay
                </div>
                <Pricing
                  small
                  accented
                  value={cartValue}
                  originalValue={cartOriginalValue}
                />
              </div>

              <PrimaryButton type="submit" big full loading={submitting} disabled={submitting || submitSucceeded}>
                <FormattedMessage id="section.generic.proceed-to-payment" />
              </PrimaryButton>
            </div>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/checkout/CheckoutForm.js